export class GroupKeyQueue {
    currentGroupKey;
    queuedGroupKey; // a group key queued to be rotated into use after the call to useGroupKey
    streamId;
    identity;
    groupKeyManager;
    static async createInstance(streamId, identity, groupKeyManager, currentGroupKey) {
        const instance = new GroupKeyQueue(streamId, identity, groupKeyManager);
        instance.currentGroupKey = currentGroupKey ?? await instance.groupKeyManager.fetchLatestEncryptionKey(await identity.getUserId(), streamId) ?? undefined;
        return instance;
    }
    constructor(streamId, identity, groupKeyManager) {
        this.streamId = streamId;
        this.identity = identity;
        this.groupKeyManager = groupKeyManager;
    }
    async useGroupKey() {
        // Ensure we have a current key by picking a queued key or generating a new one
        if (!this.currentGroupKey) {
            this.currentGroupKey = this.queuedGroupKey ?? await this.rekey();
            this.queuedGroupKey = undefined;
        }
        // Always return an array consisting of currentGroupKey and queuedGroupKey (latter may be undefined)
        const result = {
            current: this.currentGroupKey,
            next: this.queuedGroupKey,
        };
        // Perform the rotate if there's a next key queued
        if (this.queuedGroupKey) {
            this.currentGroupKey = this.queuedGroupKey;
            this.queuedGroupKey = undefined;
        }
        return result;
    }
    async rotate(newKey) {
        const publisherId = await this.identity.getUserId();
        newKey = await this.groupKeyManager.storeKey(newKey, publisherId, this.streamId);
        this.queuedGroupKey = newKey;
        return newKey;
    }
    async rekey(newKey) {
        const publisherId = await this.identity.getUserId();
        newKey = await this.groupKeyManager.storeKey(newKey, publisherId, this.streamId);
        this.currentGroupKey = newKey;
        this.queuedGroupKey = undefined;
        return newKey;
    }
}
